import { useState,useEffect } from "react";
import { useSpring, animated } from "react-spring";

const ProgressBar = ({value}) => {
   
    const[count,setCount]=useState(0)
    const[isProgress,setProgres]=useState(false)
    useEffect(() => {
        setProgres(!isProgress);
      }, []); // Run only once when the component mounts
      useEffect(() => {
        if (count < value) {
          const timeout = setInterval(() => {
            setCount((prevCount) => prevCount + 1);
          }, 0.5);
          return () => clearTimeout(timeout);
        }
      }, [count, value]);
     
    
      const slide = useSpring({
        width: isProgress ? `${value}%` : "0%",
        config: { duration: 2000 },
      });
    return ( 
        <div className="relative w-full h-4 rounded-full bg-white">
<animated.div style={slide} className="h-full bg-yellow-500 rounded-full"></animated.div>
<div  className="absolute top-0 w-full text-center text-black text-sm "><span id="count">{count<value?count:value}</span>%</div>
        </div>
     );
}
 
export default ProgressBar;